module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "id": "dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("For my wonderful grandchildren Olivia, Annie and Arthur")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/elephant.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_c('i', [_vm._v("‘You make the world a little softer")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_c('i', [_vm._v("A little kinder")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_c('i', [_vm._v("A little warmer.’")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e332cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 75
// module chunks = 0